import BaseIcon from './base-icon';

class CupIcon extends BaseIcon {
  renderSVG(): string {
    return `
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3333 2.66669V5.33335M18.6667 2.66669V5.33335M21.3333 10.6667C21.687 10.6667 22.0261 10.8072 22.2761 11.0572C22.5262 11.3073 22.6667 11.6464 22.6667 12V22.6667C22.6667 24.0812 22.1048 25.4377 21.1046 26.4379C20.1044 27.4381 18.7478 28 17.3333 28H9.33333C7.91885 28 6.56229 27.4381 5.5621 26.4379C4.5619 25.4377 4 24.0812 4 22.6667V12C4 11.6464 4.14048 11.3073 4.39052 11.0572C4.64057 10.8072 4.97971 10.6667 5.33333 10.6667H24C25.4145 10.6667 26.771 11.2286 27.7712 12.2288C28.7714 13.229 29.3333 14.5855 29.3333 16C29.3333 17.4145 28.7714 18.7711 27.7712 19.7713C26.771 20.7715 25.4145 21.3334 24 21.3334H22.6667M8 2.66669V5.33335" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;
  }
}

customElements.define('cup-icon', CupIcon);
